// The admin app is served under `/app` of the main host or on its own host (VITE_ADMIN_BASE=/)
export const APP_BASE = import.meta.env.BASE_URL.replace(/\/$/, '')

// Absolute path of an admin app page
export function appPath(path: string) {
  return `${APP_BASE}${path}`
}
